import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};

const RowItem = ({ title, events, severity }) => {

  const colorMap = {
    High: "#f97316",
    Critical: "#ef4444",
    Medium: "#fde047"
  };

  return (
    <div
      className="d-flex justify-content-between align-items-center mb-3"
      style={{
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: "6px",
        padding: "10px"
      }}
    >
      <div>
        <div>{title}</div>
        <small className="text-muted">{events}</small>
      </div>

      <span
        style={{
          background: `rgba(${severity === "Critical" ? "239,68,68" : severity === "High" ? "249,115,22" : "250,204,21"},0.15)`,
          color: colorMap[severity],
          fontSize: "11px",
          padding: "3px 10px",
          borderRadius: "999px",
          fontWeight: "600"
        }}
      >
        {severity}
      </span>
    </div>
  );
};

const ICSProtocolThreatDetection = () => {
  return (
    <Card style={{ ...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-radar-line" style={pageIconStyle} ></i>
          </div>
          ICS Protocol Threat Detection
        </h5>
      </CardHeader>

      <CardBody>

        <RowItem
          title="Modbus Write Commands"
          events="12 events detected"
          severity="High"
        />

        <RowItem
          title="PLC Memory Write Attempts"
          events="4 events detected"
          severity="Critical"
        />

        <RowItem
          title="Illegal Function Code Usage"
          events="22 events detected"
          severity="Medium"
        />

        <RowItem
          title="DNP3 Suspicious Commands"
          events="1 events detected"
          severity="High"
        />

        <RowItem
          title="OPC UA Unauthorized Access"
          events="8 events detected"
          severity="Medium"
        />

      </CardBody>
    </Card>
  );
};

export default ICSProtocolThreatDetection;